import { render, staticRenderFns } from "./KidGradeSubjectCategories.vue?vue&type=template&id=1a2fe672&scoped=true"
import script from "./KidGradeSubjectCategories.vue?vue&type=script&lang=js"
export * from "./KidGradeSubjectCategories.vue?vue&type=script&lang=js"
import style0 from "./KidGradeSubjectCategories.vue?vue&type=style&index=0&id=1a2fe672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fe672",
  null
  
)

export default component.exports